/** ISO calendar date YYYY-MM-DD utilities (no timezone). */

const ISO_RE = /^\d{4}-\d{2}-\d{2}$/;

export function assertIsoDate(s: string): string {
  if (!ISO_RE.test(s)) {
    throw new Error(`Invalid ISO date: ${s}`);
  }
  const [y, m, d] = s.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (
    dt.getUTCFullYear() !== y ||
    dt.getUTCMonth() !== m - 1 ||
    dt.getUTCDate() !== d
  ) {
    throw new Error(`Invalid calendar date: ${s}`);
  }
  return s;
}

export function compareIso(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0;
}

export function daysInMonth(year: number, month: number): number {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function addMonths(iso: string, months: number): string {
  const [y, m, d] = iso.split("-").map(Number);
  let month = m - 1 + months;
  let year = y + Math.floor(month / 12);
  month = ((month % 12) + 12) % 12;
  const day = Math.min(d, daysInMonth(year, month + 1));
  return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function addDays(iso: string, days: number): string {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  return dt.toISOString().slice(0, 10);
}

export function isMonthEnd(iso: string): boolean {
  const [y, m, d] = iso.split("-").map(Number);
  return d === daysInMonth(y, m);
}

export function utcTodayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function firstOfMonth(iso: string): string {
  return `${iso.slice(0, 7)}-01`;
}

export function yearOf(iso: string): number {
  return Number(iso.slice(0, 4));
}
